var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 41,
    viewBox: "0 0 42 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0439453,
    width: 41.183,
    height: 40.5065,
    rx: 20.2532,
    fill: "#12B897"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2316 26.2578V28.2969H17.0553V26.2578H19.9482V18.2824C19.9482 18.1083 19.9515 17.9308 19.9582 17.75C19.9649 17.5692 19.9749 17.3851 19.9883 17.1976L18.0799 18.7846C17.9459 18.8851 17.8153 18.9487 17.6881 18.9755C17.5609 19.0023 17.4403 19.0056 17.3265 18.9855C17.2127 18.9587 17.1122 18.9185 17.0252 18.865C16.9381 18.8047 16.8712 18.7444 16.8243 18.6842L15.9504 17.509L20.4303 13.7121H22.7104V26.2578H25.2316Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep01);
export default __webpack_public_path__ + "static/media/step-01.ce75f81ab3359bc5b1b45321219c0b5c.svg";
export { ForwardRef as ReactComponent };